exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".door-blooking-container{\n    background: #f0f0f0;\n}\n.acn-cell-title {\n    padding-top: 0px;\n    padding-bottom: 5px;\n    height: 18px;\n    font-size: 13px;\n    color: #00243D;\n    display: inline-block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n}\n.input-options{\n    padding-top: 20px;\n    padding-left: 21px;\n    width: 220px;\n    z-index: 10;\n}\n.result-table{\n    margin-top: -20px;\n}\n.buttons{\n    display: -ms-flexbox;\n    display: flex;\n    margin-left: 22px;\n    margin-top: -4px;\n    padding-bottom: 20px;\n}\n.lfwms-btn-default{\n    margin: 0px;\n    font-size: 13px;\n}\n.buttons .lfwms-btn-default:not(:first-child){\n    margin-left: 4px;\n}\n.lfwms-btn-default:hover{\n    color: #ffffff;\n    background-color: #0073AB;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/dock-door-booking-popups/door-add-booking-detail-popup/door-add-booking-detail-popup.component.css
// module id = ../../../../../src/app/shared/lookup/dock-door-booking-popups/door-add-booking-detail-popup/door-add-booking-detail-popup.component.css
// module chunks = main